import { CommonModule, DatePipe } from '@angular/common';
import { HttpResponse } from '@angular/common/http';
import {
  Component,
  Input,
  OnInit,
  SimpleChanges,
  Output,
  EventEmitter,
  OnChanges,
  ViewChild,
  TemplateRef,
  inject,
  ChangeDetectorRef,
} from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzTimePickerModule } from 'ng-zorro-antd/time-picker';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzCardModule } from 'ng-zorro-antd/card';
//import { UploadComponent } from '../../../shared/components/upload/upload.component';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { UploadComponent } from '../../../../../shared/components/upload/upload.component';
import { NzI18nService } from 'ng-zorro-antd/i18n';
import { ReferralDataService } from '../../../../../services/referral-data.service';
import { SectionsService } from '../../../../../services/sections.service';
import { LeadDetailsService } from '../../../../../services/lead-details.service';
import { ListTableComponent } from '../../../../../shared/components/list-table/list-table.component';
import {
  STATIC_JSON_DATA_PATH,
  STATIC_DATA,
  ENROLLMENT_TYPE_BACKEND_MAPPINGS,
  ENROLLMENT_TYPE_UI_TO_BACKEND_MAPPINGS,
} from '../../../../../shared/constants/static-data.constants';
import { BaseComponent } from '../../../../../shared/utils/base.component';
import { LoggerService } from '../../../../../shared/services/logger.service';
import { TableRowActionsModel } from '../../../../../shared/interfaces/list.interface';
import { TableRowActions } from '../../../../../shared/interfaces/actions';
import { ListService } from '../../../../../shared/services/list.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { SharedDataService } from '../../../../../shared/services/shared-data-service';
import { SharedService } from '../../../../../shared/services/shared.service';
import { ButtonComponent } from '../../../../../shared/components/button/button.component';
import { UserService } from '../../../../../services/user.service';
import { StorageService } from '../../../../../services/storage.service';
import {
  DialogConfig,
  DialogService,
} from '../../../../../shared/services/dialog.service';
import { DropdownSelectComponent } from '../../../../../shared/components/dropdown-select/dropdown-select.component';
import { environment } from '../../../../../../environments/environment';
import { FileUploadNotificationService } from '../../../../../services/file-upload-notification.service';
import {
  AcknowledgeItem,
  AcknowledgeFileUploadNotificationResponse,
  FileUploadNotificationData
  } from '../../../../../interfaces/file-upload-notification.interface';
  import { finalize } from 'rxjs/operators';
  import { NotificationService } from '../../../../../shared/services/notification.service';
import { AuthorizationUtility } from '../../../../../shared/authorization/auth.utility';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { PopupDialogComponent } from '../../../../../shared/components/popup-dialog/popup-dialog.component';
@Component({
  selector: 'ppl-file-upload',
  standalone: true,
  imports: [
    NzToolTipModule,
    NzSelectModule,
    NzFormModule,
    NzInputModule,
    NzTimePickerModule,
    ReactiveFormsModule,
    NzCheckboxModule,
    NzCardModule,
    UploadComponent,
    NzRadioModule,
    NzIconModule,
    NzButtonModule,
    NzToolTipModule,
    ListTableComponent,
    CommonModule,
    ButtonComponent,
    DropdownSelectComponent,
    NgxExtendedPdfViewerModule,
    PopupDialogComponent,
  ],
  templateUrl: './file-upload.component.html',
  styleUrl: './file-upload.component.css',
})
export class FileUploadComponent
  extends BaseComponent
  implements OnInit, OnChanges
{
  servicesForm!: FormGroup;
  uploadForm: FormGroup = this.fb.group({
    document_type: [''],
    other_type: [''],
  });
  fileList: any;
  @Input() filedInfo: any;
  @Input() tableWidth?: any;
  @Input() summary?: any;
  mode = 'read';
  steps: any = {};
  cols: any;
  fileListInfo: any[] = [];
  actionButtons: TableRowActionsModel = new TableRowActions({ edit: true, view: true });
  showDeleteConfirmation = false;
  private readonly nonPreviewableFileTypes = ['doc', 'docx', 'csv', 'xls', 'xlsx'];
  private readonly imageExtensions = ['png', 'jpg', 'jpeg'];
  private readonly textExtensions = ['txt'];
  previewKind: 'pdf' | 'image' | 'text' | null = null;
  previewSrc: any;
  previewText = '';
  program: any;
  //entry: any;
  filledInfo: any;
  approvedStatus: string = STATIC_DATA.APPROVED;
  leadStatus = '';
  leadStatusRaw?: string;
  leadId: string | null = '';
  licences: any[] = [];
  fileId = '';
  customType = '';
  isMobileView = window.innerWidth <= 768;
  message: any =
    'Please select a document type and upload supporting documents for it';
    selectedForAck: AcknowledgeItem[] = [];
  programCode = this.userService.getSelectedProgram()?.program_code || 'NY';
  isAckLoading = false;
  fileDetailsArr: any[] = [];
  @Input() flow: any;
  type: any;
  statusReady = false;
  canAcknowledge = false;
  private applicationSubmitted = '';
 

  private getRowId(r: any): number {
    return Number(r?.fileId ?? r?.leadFileId ?? r?.leadfileId ?? r?.id);
    }
   public isAcked = (r:any) => {
      const v = r?.acknowledged === true || r?.is_acknowledged === true || r?.isAcknowledged === true;
      return v;
      };
      
    
    private isEligibleForAck = (r: any): boolean => !!r && !this.isAcked(r);

  @Input() set sectionData(data: any) {
    this.steps = data;
  }

  @Input() entry = 'base';
  @Input() readonly = false;
  @Input() showButtons? = true;
  @Input() showUpload? = true;
  @Input() selectedLead = 0;
  @Input() authId? = null;
  @Input() pageId = '';
  @Input() tabId = '';
  @Output() filesUpdated = new EventEmitter();
  @ViewChild('fileEditDialog') fileEditDialog!: TemplateRef<any>;
  @ViewChild('documentDialog') documentDialog!: TemplateRef<any>;

  private dialogSvc = inject(DialogService);

  constructor(
    private sectionsService: SectionsService,
    private leadDetailsService: LeadDetailsService,
    private logger: LoggerService,
    private sharedDataService: SharedDataService,
    private sharedService: SharedService,
    private userService: UserService,
    private storageService: StorageService,
    private fb: FormBuilder,
    private fileUploadNotificationService: FileUploadNotificationService,
    private msg: NzMessageService,
    private cdr: ChangeDetectorRef,
    private notificationService: NotificationService,
    private authUtility: AuthorizationUtility,
  ) {
    super();
  }

  get isAckSupported(): boolean {
    const entry = (this.entry ?? '').toLowerCase();
    const userDetails = this.userService.getUserDetails();
    const isPPLAdmin =
      this.program?.roles?.some(
        (role: any) => role.role_name === 'PPL Admin' || role.role_name === 'Compliance',
      ) && userDetails?.usertype_lkp === 'FMS';
    if (['referral', 'auth', 'provider'].includes(entry)) {
      return false;
    }
    if (entry === 'participantenrollment' || entry === 'providerenrollment') {
      console.log('Lead Status:', this.leadStatus );
      return ['in ppl review', 'registration active', 'paperwork complete', 'on hold', 'enrollment complete',
        'registration inactive', 'blocked', 'returned']
      .includes((this.leadStatus ?? '').toLowerCase());
      }
    return false;
  }

    get canAckSelected(): boolean {
      return Array.isArray(this.selectedForAck) && this.selectedForAck.length > 0;
      }

  ngOnInit(): void {
    console.log('FLOW CHECK => entry:', this.entry);
    // console.log("filedinfo in file com, this.fil", this.filedInfo)
    this.program = this.userService.getSelectedProgram();
    this.flow = this.sectionsService.getFlow();
    this.type = this.flow || this.userService.getLeadEntry();
    const isEnrollmentEntry =
      this.entry.toLowerCase() === 'participantenrollment' ||
      this.entry.toLowerCase() === 'providerenrollment';
    this.actionButtons.view = isEnrollmentEntry;

    if (isEnrollmentEntry) {
      this.canAcknowledge = this.authUtility.isSectionEditable(
        this.pageId,
        this.tabId,
        'Acknowledge',
      );
    }

    // this.entry =
    //   this.userService.getLeadEntry() ?? '';
    // this.sectionsService.setFlow(this.entry);
    // this.entry = this.sectionsService.getFlow()!;
    this.leadId = this.userService.getSelectedLead() || this.storageService.getParticipantId() || '';
    if (this.entry === 'auth' && this.authId != null) {
      this.leadId = this.authId;
    }
    this.licences = this.getLookup('License_Type');
    this.getFromData();
    if (this.entry === 'auth'){
      this.message = 'Please upload supporting documents'
    }
    this.leadDetailsService.getLeadStatus().subscribe((status: string) => {
      this.leadStatusRaw = status ?? '';
      this.leadStatus = (status ?? '').trim().toLowerCase();
      console.log(this.leadStatus);
      this.statusReady = true;
      this.cdr?.markForCheck?.();

      if (this.leadStatus === this.approvedStatus) {
        this.actionButtons.download = false;
        this.actionButtons.delete = false;
        this.actionButtons.edit = false;
      } else {
        this.actionButtons.download = true;
        this.actionButtons.delete = true;
        this.actionButtons.edit = true;
      }
    });
    this.leadDetailsService.getUpdatedLeadData().subscribe((data) => {
      this.filledInfo = data?.responsedata?.infoData;
      this.leadStatus = this.filledInfo?.applicationStatus;
      const raw = (this.filledInfo?.applicationStatus ?? '').trim();
      this.leadStatusRaw = raw;
      this.leadStatus = raw.toLowerCase();
      this.statusReady = true;
      this.cdr?.markForCheck?.();
    });
      if(this.entry === STATIC_DATA.PARTICIPANT_ENROLLMENT || this.entry === STATIC_DATA.PROVIDER_ENROLLMENT) {
        this.leadDetailsService
        .fetchLeadDetailsApi(
          this.entry,
          this.program.program_code,
          Number(this.leadId),
        )
        .subscribe((data) => {
          if (this.entry === STATIC_DATA.PROVIDER_ENROLLMENT) {
            const associations = data?.responsedata?.participantAssociations;
            if (!associations) {
              this.licences = [];
              return;
            }
            const providerTypesList =
              associations
                .filter((provider: any) =>
                  provider.associationStatus !== 'Disassociated',
                )
                .map(
                  (provider: any) =>
                    ENROLLMENT_TYPE_BACKEND_MAPPINGS[provider.providerType],
                );
                if (providerTypesList.length > 0) {
              const mappedList = providerTypesList.map(
                (item: any) => ENROLLMENT_TYPE_UI_TO_BACKEND_MAPPINGS[item],
              );

              const docsPayload = {
                associationTypes: mappedList,
                programCode: this.program.program_code,
              };
              this.lookupService
                .getDocumentsLookup(docsPayload)
                .subscribe((data: any) => {
                  console.log('docs list custom', data.responsedata);
                  this.licences = data.responsedata[0].lookupValue;
                });
            } else {
              this.licences = [];
            }
            } else if (this.entry === STATIC_DATA.PARTICIPANT_ENROLLMENT) {
            const docsPayload = {
              associationTypes: ['PTC'],
              programCode: this.program.program_code,
            };

            this.lookupService
              .getDocumentsLookup(docsPayload)
              .subscribe((data: any) => {
                console.log('docs list custom', data.responsedata);
                this.licences = data.responsedata[0].lookupValue;
              });
          }
        })
      }
  }
  private resolveUserType(): 'participant' | 'provider' {
    const map: Record<string, 'participant' | 'provider'> = {
    participantenrollment: 'participant',
    providerenrollment: 'provider',
    provider: 'provider',
    };
    const key = (this.entry ?? '').toString().toLowerCase().trim();
    return map[key] ?? 'participant'; 
    }
 private toAckItem(row: any): AcknowledgeItem {
    const fileId = row.fileId ?? row.leadFileId ?? row.leadfileId ?? row.file_id ?? row.id;
    const userType = this.resolveUserType();
    return { fileId: Number(fileId), userType };
    }
onSelectionChange(rows: any[]): void {
    const incoming = Array.isArray(rows) ? rows : [];
    if (!incoming.length) {
      this.selectedForAck = [];
      return;
    }
    const byId = new Map<number, any>(
      (this.fileListInfo ?? []).map((r: any) => [this.getRowId(r), r])
    );
    const normalized: any[] = incoming
      .map((it: any) => byId.get(Number(it?.fileId ?? it?.leadFileId ?? it?.id)))
      .filter(Boolean);
    const eligibleRows = normalized.filter(
      (r: any) => !this.isAcked(r) && this.isEligibleForAck(r)
    );
    const payload = eligibleRows.map((r: any) => this.toAckItem(r));
    const dropped = incoming.length - payload.length;
    if (dropped > 0) {
      this.fileListInfo = [...(this.fileListInfo ?? [])];
    }
    this.selectedForAck = payload;
    console.log(
      '[onSelectionChange]',
      { incoming: incoming.length, normalized: normalized.length, eligible: eligibleRows.length, dropped },
      'selectedForAck →', this.selectedForAck
    );
  }
 public onAcknowledgeClicked(): void {
    if (!this.isAckSupported) { return; }
    if (!this.selectedForAck || this.selectedForAck.length === 0) { return; }
    const byId = new Map<number, any>(
      (this.fileListInfo ?? []).map((r: any) => [this.getRowId(r), r])
    );
    const payload: AcknowledgeItem[] =
      (this.selectedForAck ?? []).filter(it => {
        const cur = byId.get(Number(it.fileId));
        return !!cur && !this.isAcked(cur);
      });
    if (payload.length === 0) { return; }
    const payloadCount = payload.length;
    this.isAckLoading = true;
    this.fileUploadNotificationService
      .acknowledgeFilesLite(payload, this.programCode)
      .pipe(finalize(() => (this.isAckLoading = false)))
      .subscribe({
        next: () => {
          const userType = this.resolveUserType();
          this.notificationService.alert('success',
            'Success',
            `Successfully acknowledged ${payloadCount} file${payloadCount === 1 ? '' : 's'}.`
          );
          this.selectedForAck = [];
          this.fileListInfo = (this.fileListInfo ?? []).map(r => ({ ...r }));
          this.cdr.detectChanges();
          this.refreshList(false);
        },
        error: () => this.msg.error('Error acknowledging file(s).')
      });
  }
private refreshList(preserveOnEmpty = false): void {
    this.isAckLoading = true;
    this.sharedService
      .getUploadedFileDetails(this.programCode, this.leadId, this.type, true)
      .pipe(finalize(() => (this.isAckLoading = false)))
      .subscribe({
        next: (res: any) => {
          const rd = res?.responseData ?? {};
          const rows: any[] =
            Array.isArray(rd.participantEnrIDocumentDetails) ? rd.participantEnrIDocumentDetails :
              Array.isArray(rd.referralDocumentDetails) ? rd.referralDocumentDetails :
                (Object.values(rd).find((v: any) => Array.isArray(v)) as any[]) || [];
          if (preserveOnEmpty && rows.length === 0 && (this.fileListInfo?.length ?? 0) > 0) {
            console.warn('[refreshList] Empty rows from API; preserving current grid.');
            return;
          }
          this.selectedForAck = [];
          this.fileListInfo = [];
          setTimeout(() => {
            this.fileListInfo = rows;
            this.filesUploaded([...rows]);
            console.log('[refreshList] rows loaded:', rows.length);
          }, 0);
        },
        error: () => this.msg.error('Error refreshing file list.')
      });
  }

  filesUploaded(files: any) {
    console.log('Files List', files);
    this.fileList = files;
    this.selectedForAck = [];
    this.filesUpdated.emit();
  }

  cancelEdit() {
    this.mode = 'read';
    //this.leadUpdated.emit(true);
    //need to rest the form
    //this.contactForm.reset();
  }

  async getFromData() {
    try {
      if (this.entry) {
        const tempCols = await this.sectionsService.getJsonConfigurationData(
          STATIC_JSON_DATA_PATH.LEAD_DETAILS_DOCUMENT_LIST_HEADERS,
          this.entry
        );
        this.cols = tempCols.documents.columns;
        console.log(this.cols);
      }
    } catch (e) {
      this.log.debug('Error in getting column data', e);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    try {
      if (changes['filedInfo'] && changes['filedInfo'].currentValue) {
        this.fileListInfo =
          this.entry === STATIC_DATA.PROVIDER
            ? changes['filedInfo'].currentValue.providerDocumentDetails
            : this.entry === STATIC_DATA.REFERRAL
            ? changes['filedInfo'].currentValue.referralDocumentDetails
            : this.entry === 'providerEnrollment'
            ? changes['filedInfo'].currentValue.providerEnrlDocumentDetails
            : this.entry === 'auth'
            ? changes['filedInfo'].currentValue.consumerAuthDocumentDetailsList
            : changes['filedInfo'].currentValue.participantEnrlDocumentDetails;
        this.logger.info(
          'fileListInfo',
          changes['filedInfo'].currentValue.providerDocumentDetails
        );
        if (!this.fileListInfo) {
          this.fileListInfo = [];
        }
        this.fileListInfo = this.fileListInfo.map((item) => {
          const resolved =
            item.lkpValueName === null && item.otherType
              ? { ...item, lkpValueName: item.otherType }
              : item;
          return {
            ...resolved,
            actions: { view: this.isPreviewable(resolved.fileType) },
          };
        });
        console.log('File List', this.fileListInfo);
      }
    } catch (e) {
      this.logger.info(
        'Error in getting section data and updating latest info',
        e
      );
    }
  }

  action(event: any): void {
    this.logger.debug('Action', event);
    const selectedFileName = event.data.fileName;

    switch (this.entry) {
      case STATIC_DATA.REFERRAL:
        this.fileId = event.data.referralFileId;
        break;
      case STATIC_DATA.PARTICIPANT_ENROLLMENT:
        this.fileId = event.data.leadFileId;
        break;
      case STATIC_DATA.PROVIDER_ENROLLMENT:
        this.fileId = event.data.fileId;
        break;
      case 'auth':
        this.fileId = event.data.fileId;
        break;
      default:
        this.fileId = event.data.leadFileId;
    }
    // : event.data.referralFileId;
    // let flow = entry.charAt(0).toUpperCase() + entry.slice(1).toLowerCase();
    if (event.action === 'view') {
      this.viewFile(selectedFileName, this.fileId, event.data.fileType);
    }
    if (event.action === 'download') {
      this.mode = 'edit';
      this.fecthcFile(selectedFileName, this.fileId);
      // this.servicesForm.patchValue(event.data);
    }
    if (event.action === 'delete') {
      this.showDeleteConfirmation = true;
      // this.servicesForm.patchValue(event.data);
    }
    if (event.action === 'edit') {
      console.log(event);
      this.mode = 'edit';
      this.uploadForm.patchValue({ document_type: event.data.otherType });
      this.openEditFileDialog();
    }
  }

  openEditFileDialog() {
    const dialogConfig: DialogConfig = {
      title: `File Type`,
      isOkText: 'Update',
      size: 'medium',
      position: 'top',
      showClose: true,
      showButtons: true,
    };

    this.dialogSvc.openDialog(
      this.fileEditDialog,
      dialogConfig,
      () => this.handleUpdate(),
      () => this.handleCancel()
    );
  }

  handleUpdate() {
    const payload = {
      otherType: '',
    };
    if (this.uploadForm.get('document_type')?.value === 'OTH') {
      payload.otherType = this.uploadForm.get('other_type')?.value;
    } else {
      payload.otherType = this.uploadForm.get('document_type')?.value;
    }

    this.sharedService
      .updateFile(
        this.program.program_code,
        this.fileId,
        payload,
        this.sharedDataService.getType(this.entry)
      )
      .subscribe((data: any) => {
        console.log(data);
        this.filesUpdated.emit();
      });
  }

  handleCancel() {}

  docTypeChanged(event: any) {
    console.log(this.uploadForm.get('document_type')?.value);
    if (event === 'OTH') {
      this.uploadForm.get('other_type')?.setValue('');
    }
  }

  add(): void {
    this.mode = 'add';
  }

  deleteFile() {
    const createType = this.leadId === '' ? 'new' : 'detail';
    this.sharedService
      .deleteFile(
        this.program.program_code,
        this.fileId,
        createType,
        this.sharedDataService.getType(this.entry)
      )
      .subscribe((data: any) => {
        console.log(data);
        // this.msg.success(`File deleted successfully`);
        this.filesUpdated.emit();
      });
  }

  isPreviewable(fileType: string): boolean {
    return !this.nonPreviewableFileTypes.includes((fileType ?? '').toLowerCase());
  }

  handleConfirmDelete() {
    this.showDeleteConfirmation = false;
    this.deleteFile();
  }

  onDeleteDialogClose() {
    this.showDeleteConfirmation = false;
  }

  viewFile(selectedFileName: string, fileId: string, fileType: string) {
    const type = (fileType ?? '').toLowerCase();

    if (this.nonPreviewableFileTypes.includes(type)) {
      // No in-app preview yet for these formats; fall back to download.
      this.fecthcFile(selectedFileName, fileId);
      return;
    }

    this.sharedService
      .viewFile(
        this.program.program_code,
        this.sharedDataService.getType(this.entry),
        fileId,
      )
      .subscribe((response: HttpResponse<Blob>) => {
        if (!response.body) return;

        if (type === 'pdf') {
          this.previewKind = 'pdf';
          this.previewSrc = window.URL.createObjectURL(response.body);
          this.openDocumentDialog(selectedFileName);
        } else if (this.imageExtensions.includes(type)) {
          this.previewKind = 'image';
          this.previewSrc = window.URL.createObjectURL(response.body);
          this.openDocumentDialog(selectedFileName);
        } else if (this.textExtensions.includes(type)) {
          response.body.text().then((text) => {
            this.previewKind = 'text';
            this.previewText = text;
            this.openDocumentDialog(selectedFileName);
          });
        } else {
          this.fecthcFile(selectedFileName, fileId);
        }
      });
  }

  openDocumentDialog(fileName: string) {
    const dialogConfig: DialogConfig = {
      title: fileName,
      size: 'x-large',
      position: 'top',
      showClose: true,
      showButtons: false,
    };

    this.dialogSvc.openDialog(
      this.documentDialog,
      dialogConfig,
      () => this.handleViewDialogClose(),
      () => this.handleViewDialogClose(),
    );
  }

  handleViewDialogClose() {
    if (this.previewSrc) {
      window.URL.revokeObjectURL(this.previewSrc);
    }
    this.previewSrc = null;
    this.previewText = '';
    this.previewKind = null;
  }

  save() {
    //added update functionality for licenses
    // let payLoad:any={};
    // let servicesRendered: any=[];
    // this.servicesForm.controls['profLicences'].value.map((x: any)=>servicesRendered.push({serviceType:x}))
    // console.log(this.filledInfo.contactDetailsData.leadId)
    // payLoad={
    //   'leadId': this.filledInfo.contactDetailsData.leadId,
    //   'servicesRendered':servicesRendered
    // }
    // this.leadDetailsService.updateProfessionalLicense(payLoad, this.entry).subscribe(() => {
    //   this.logger.info('Lead Provider Service is sucessfully updated!');
    //   //this.servicesForm.reset();
    //   this.leadUpdated.emit(true);
    //   this.mode = 'read'
    // })
  }

  editInfo() {
    this.mode = 'edit';
    // this.patchLicenseData();
    // this.contactForm.patchValue(this.filledInfo);
    // this.contactForm.controls['leadId'].setValue(this.filledInfo?.permanentAddress?.leadId || this.selectedLeadId);
  }

  // downloadFileFromServer(fileUrl: string) {
  //   this.http.get(fileUrl, {responseType: 'blob'}).subscribe((blob) => {
  //   })
  // }

  fecthcFile(selectedFileName: string, fileId: string) {
    this.sharedService.downloadFile(
      this.program.program_code,
      this.sharedDataService.getType(this.entry),
      fileId,
      selectedFileName
    );
  }
}
